module.exports = {"430811001":"军地坪街道","430811002":"锣鼓塔街道","430811201":"协合乡","430811202":"中湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430811.json
// module id = 1881
// module chunks = 0